import React, { createContext, useContext } from "react";

// Create the context with default styles
const BoxContext = createContext();

// Provider component that will pass down the box styles and content
export const BoxProvider = ({
  children,
  heading,
  description,
  image,
  gradientColor = "#007bff",
  buttonVariant = "outline-danger",
  heading2,
  description2,
  image2,
  gradientColor2 = "#ff7f50",
  buttonVariant2 = "outline-danger",
  link1 = "/",
  link2 = "/",
  showButton = true, // Add showButton with default true
}) => {
  const boxStyles = {
    width: "100%",
    margin: "0 auto",
    padding: "20px",
    borderRadius: "50px",
    background: `linear-gradient(to right, white, ${gradientColor})`,
    alignItems: "center",
    marginBottom: "20px",
  };

  const boxStyles2 = {
    width: "100%",
    margin: "0 auto",
    padding: "20px",
    borderRadius: "50px",
    background: `linear-gradient(to left, white, ${gradientColor2})`,
    alignItems: "center",
  };

  const contentStyles = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  return (
    <BoxContext.Provider
      value={{
        boxStyles,
        contentStyles,
        heading,
        description,
        image,
        buttonVariant,
        boxStyles2,
        heading2,
        description2,
        image2,
        buttonVariant2,
        link1,
        link2,
        showButton, // Add to context
      }}
    >
      {children}
    </BoxContext.Provider>
  );
};

// Custom hook to use the Box context
export const useBoxStyles = () => useContext(BoxContext);